export enum WizardSubmitProgress {
  AUDIO_UPLOADING = 'AUDIO_UPLOADING',
  VIDEO_UPLOADING = 'VIDEO_UPLOADING',
  IMAGE_UPLOADING = 'IMAGE_UPLOADING',
  WAVEFORM_GENERATING = 'WAVEFORM_GENERATING',
  PROJECT_CREATING = 'PROJECT_CREATING',
}
